import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { userApi } from "api/userApi";
import { syncFbcToAccount } from "analytics/metaCapi";

/**
 * userPromotionAtom에 accessToken은 있지만 nickname 등의 정보가 없을 때
 * userApi.getSimple()을 호출하여 전체 user 정보를 가져오는 훅
 */
export default function useFetchUserPromotion() {
  const [isFetching, setIsFetching] = useState(false);
  const [user, setUser] = useRecoilState(userSimpleAtom);

  useEffect(() => {
    // accessToken은 있지만 userId 없으면 user 정보 가져오기
    if (user?.accessToken && !user?.userId && !isFetching) {
      setIsFetching(true);

      const fetchUser = async () => {
        try {
          const response = await userApi.getSimplePromotion();

          if (response.code === 0 && response.result) {
            setUser((prev) => ({
              ...prev,
              ...response.result,
            }));

            // 로그인 이벤트 없이 유저가 식별되는 지점 — 서버 저장 fbc를 최신 클릭으로 동기화
            syncFbcToAccount(response.result.userId);
          }
        } catch (error) {
          console.error("Failed to fetch user info:", error);
        } finally {
          setIsFetching(false);
        }
      };

      fetchUser();
    }
  }, [user?.accessToken, user?.userId, isFetching, setUser]);

  return { isFetching };
}
